import React from 'react';
import { AuthCompanyContext } from '@homesusa/auth';
import { AppContext } from '../contexts';
import { SidebarItem } from '../interfaces';
import { getCommonSidebarItems } from '../utils/sidebar-items';

export const useSyncSidebarItems = (
  currentItems: Record<string, SidebarItem>,
  deps: React.DependencyList = []
): void => {
  const { appStateDispatch } = React.useContext(AppContext);
  const { currentCompany } = React.useContext(AuthCompanyContext);

  React.useEffect(() => {
    const baseSidebarItems = { ...currentItems };
    const sidebarItemsCommon = getCommonSidebarItems(currentCompany);

    const updatedItems = {
      ...baseSidebarItems,
      ...sidebarItemsCommon
    };

    appStateDispatch({
      type: 'UpdateSidebarItem',
      payload: updatedItems
    });
  }, [appStateDispatch, currentCompany, ...deps]);
};
